// extracted by mini-css-extract-plugin
module.exports = {"input":"ezAdOh","inputSrOnly":"cxVjBG","focusRing":"gz6aX8","label":"BWoMiM","selected":"lomt0A"};